import { JOB_SOURCES } from '@chukua/common';
import { DatePicker, Form, Input, InputNumber, Select } from 'antd';
import { JOB_SOURCE_LABELS } from '../policies/job-source-labels';
import { ZoneSearchSelect } from '../../../../zones/public/ZoneSearchSelect';

/** Everything fillable now or later — source, who asked, quantity, zones, dates — shared shape by JobIntakeForm, kept out of it to stay under the line limit. */
export function JobIntakeDetailFields() {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="source" label="Source">
          <Select allowClear options={JOB_SOURCES.map((source) => ({ value: source, label: JOB_SOURCE_LABELS[source] }))} />
        </Form.Item>
        <Form.Item name="requestedQuantity" label="Quantity (e.g. number of trucks)">
          <InputNumber className="w-full" min={1} step={1} placeholder="1" />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="contactName" label="Who asked — name">
          <Input />
        </Form.Item>
        <Form.Item name="contactPhone" label="Who asked — phone">
          <Input inputMode="tel" placeholder="0712 345 678" />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="originZoneCode" label="Origin zone">
          <ZoneSearchSelect />
        </Form.Item>
        <Form.Item name="destinationZoneCode" label="Destination zone">
          <ZoneSearchSelect />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="requestedDate" label="Requested date">
          <DatePicker className="w-full" />
        </Form.Item>
        <Form.Item name="customerDeliveryDeadline" label="Customer delivery deadline">
          <DatePicker className="w-full" />
        </Form.Item>
      </div>
    </>
  );
}
